<script>
  import { onMount } from "svelte";
  import Marquee from 'svelte-fast-marquee';

  export let firstStop;
  export let systemUrl;
  export let groupId;

  let agency = firstStop != null ? firstStop.substring(0,3) : groupId != null ? 'GUI' : '';
  let announStops;
  let announGeneric;
  let hasAnnouncements = false;

  if (agency != '' || groupId != null) {
    let apiUrl = `https://${systemUrl}/v3/busdata/announcement`;

    const request = async () => {

      let bodyTemp = {
        offset: 0,
        limit: 20,
        language: 'pt',
        agency: agency,
        order_by: "priority",
        sort_by: "ASC"
      }

      if(agency != ''){
        bodyTemp['stop_id'] = firstStop
      }

      if(groupId != null){
        bodyTemp['group_id'] = groupId
      }

      let bodyStops = JSON.stringify(bodyTemp);

      const resStop = await fetch(
        apiUrl, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: bodyStops
      });

      const resAnnounStops = await resStop.json();

      announStops = resAnnounStops.results;

      if (resAnnounStops.total > 0) {
        hasAnnouncements = true
      }

      let bodyGeneric = JSON.stringify({
        offset: 0,
        limit: 20,
        agency: agency,
        language: 'pt',
        order_by: "priority",
        sort_by: "ASC"
      });

      const resGeneric = await fetch(
        apiUrl, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: bodyGeneric
      });
      const resAnnounGeneric = await resGeneric.json();

      announGeneric = resAnnounGeneric.results;

      if (resAnnounGeneric.total > 0) {
        hasAnnouncements = true
      }

    };

    announStops = []
    announGeneric = []

    onMount(() => {
      request(); // first request
      const interval = setInterval(request, 900000); // request every 15 minutes

      return () => {
        clearInterval(interval);
      };
    });
  }
  
</script>

{#if hasAnnouncements}
    <Marquee pauseOnHover={false} speed={20}>
      {#if announGeneric != undefined}
        {#each announGeneric as announcement}
          <div class="flex">
            <img class="logo-priority ml-5" alt="Anuncio" src={'img/' + announcement.priority.toLowerCase() + '_warning.png'}/>
            <p class="mx-3 announcements-text"><b>{announcement.title}:</b> {announcement.text}</p>
          </div>
        {/each}
      {/if}
      {#if announStops != undefined}
        {#each announStops as announcement}
          <div class="flex">
            <img class="logo-priority ml-5" alt="Anuncio" src={'img/' + announcement.priority.toLowerCase() + '_warning.png'}/>
            <p class="mx-3 announcements-text"><b>{announcement.title}:</b> {announcement.text}</p>
          </div>
        {/each}
      {/if}
    </Marquee>
{:else}
  <span>
    <div class="flex">
          <img class="logo-priority ml-5" alt="Anuncio" src="../img/low_warning.png"/>
          <p class="mx-3 font-bold announcements-text">Sem anúncios de momento</p>
    </div>
  </span>
{/if}

